module.exports = __webpack_public_path__ + "img/symbol_5.f59a906b.png";